import React, { FC } from "react";
import {
  AppBar,
  Box,
  Divider,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MenuIcon from "@mui/icons-material/Menu";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { setOpen } from "@store/sideBarSlice";
import AccountMenu from "@components/AccountMenu/AccountMenu";
import HeaderActions from "@components/HeaderActions/HeaderActions";
import { Link } from "react-router-dom";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { RootState } from "@store/store";
import { Mode } from "@store/homeSlice";

const LeftSide = styled(Box)`
  display: flex;
  align-items: center;
`;

const RightSide = styled(Box)`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 16px;
`;

const Branding = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  color: #000;
`;

const Header: FC<{ onboardingMode?: boolean }> = ({ onboardingMode }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { open } = useSelector((state: RootState) => state.drawer);
  const mode = useSelector((state: RootState) => state.home.mode);

  const handleMenuClick = () => {
    dispatch(setOpen(!open));
  };

  return (
    <AppBar
      color="inherit"
      position="fixed"
      elevation={0}
      sx={{
        zIndex: 1201,
        height: "64px",
        justifyContent: "center",
      }}
    >
      <Toolbar sx={{ paddingLeft: { xs: 0 } }}>
        {!onboardingMode && mode === Mode.Caregiver ? (
          <Box
            width="64px"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <IconButton
              size="medium"
              aria-label={t("header.openDrawerButton")}
              onClick={handleMenuClick}
            >
              {!open ? (
                <MenuIcon fontSize="medium" />
              ) : (
                <MenuOpenIcon fontSize="medium" />
              )}
            </IconButton>
          </Box>
        ) : null}

        <LeftSide
          sx={{
            marginLeft: "16px",
            gap: { xs: "8px", md: "16px" },
            justifyContent: {
              xs: onboardingMode ? "flex-start" : "center",
              md: "flex-start",
            },
            flex: 1,
          }}
        >
          <Branding to="/" reloadDocument={true}>
            <img
              width="45px"
              height="45px"
              src={`${process.env.PUBLIC_URL}/images/logo.png`}
              alt={process.env.REACT_APP_APP_NAME}
            />

            <Typography variant="h6">
              {process.env.REACT_APP_APP_NAME}
            </Typography>
          </Branding>
        </LeftSide>

        <RightSide>
          <HeaderActions />
          <Divider orientation="vertical" variant="fullWidth" flexItem={true} />
          <AccountMenu onboardingMode={onboardingMode} />
        </RightSide>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
